import { render, staticRenderFns } from "./BusinessUnitTemplates.vue?vue&type=template&id=a0cda862&scoped=true&"
import script from "./BusinessUnitTemplates.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitTemplates.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnitTemplates.vue?vue&type=style&index=0&id=a0cda862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cda862",
  null
  
)

export default component.exports